import React, { useEffect } from 'react';
import styled from 'styled-components';
import { Box, Button, H2, Panel, Text, Table, Flex, FlexItem } from '@bigcommerce/big-design';
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { addFiles, deleteFileByName, deleteImage, addImages } from '../reviewsSlice';
import { useDropzone } from 'react-dropzone';

const UploadBox = styled(Box)(({ theme }) => ({
    padding: theme.spacing.xLarge,
    border: `2px dashed ${theme.colors.secondary}`,
    borderRadius: '4px',
    textAlign: 'center',
    backgroundColor: theme.colors.secondary10,
}));

const ThumbFlexItem = styled(FlexItem)`
    width: 100px;
    border: 1px solid ${({theme}) => theme.colors.secondary20};
    border-radius: 2px;
    margin-right: ${({theme}) => theme.spacing.small};
    margin-bottom: ${({theme}) => theme.spacing.small};
    text-align: center;
`;

/**
 * Component quản lý hình ảnh của review
 * @param {Object} review - Dữ liệu review
 * @param {string} backUrl - URL để quay lại
 */
const ReviewImages = ({ review, backUrl }) => {
    const history = useHistory();
    const dispatch = useDispatch();
    const loading = useSelector(state => state.reviews.loading);
    const { reviewId, files } = review;

    const { getRootProps, getInputProps } = useDropzone({
        accept: 'image/*',
        onDrop: acceptedFiles => {
            const newFiles = acceptedFiles.map(file => Object.assign(file, {
                preview: URL.createObjectURL(file),
            }));
            dispatch(addFiles({ reviewId, files: newFiles }));
        }
    });

    useEffect(() => () => {
        // Make sure to revoke the data uris to avoid memory leaks
        if (files) {
            files.forEach(file => URL.revokeObjectURL(file.preview));
        }
    }, [files]);

    return (
        <Panel>
            {review ?
                <>
                    <Flex alignItems="center" justifyContent="space-between" marginBottom="large">
                        <FlexItem>
                            <H2 margin="none">Images: {review.title}</H2>
                        </FlexItem>
                        <FlexItem>
                            <Button variant="secondary" onClick={() => history.push(backUrl)}>Back</Button>
                        </FlexItem>
                    </Flex>
                    <Table
                        columns={[
                            { header: 'Image', hash: 'image', width: 150, render: item => <img src={item.smallUrl} alt="" /> },
                            { header: '', hash: 'text', render: item => '' },
                            { header: 'Action', hash: 'action', width: 200, render: item => <Button actionType="destructive" onClick={() => dispatch(deleteImage({ reviewId, imageId: item._id }))}>Delete</Button> },
                        ]}
                        items={review.images}
                        stickyHeader
                    />
                    <UploadBox marginVertical="large" {...getRootProps()}>
                        <input {...getInputProps()} />
                        <Text>Drag 'n' drop some files here, or click to select files</Text>
                    </UploadBox>
                    {files && files.length > 0 ? (
                        <>
                            <Flex flexWrap="wrap">
                                {files.map(file => (
                                    <ThumbFlexItem key={file.name} border="box">
                                        <img src={file.preview} alt="" />
                                        <Button variant="subtle" actionType="destructive" onClick={() => dispatch(deleteFileByName({ reviewId, name: file.name }))}>Delete</Button>
                                    </ThumbFlexItem>
                                ))}
                            </Flex>
                            <Box>
                                <Button isLoading={loading !== 'idle'} onClick={() => dispatch(addImages({ reviewId }))}>Upload</Button>
                            </Box>
                        </>) : ''}
                </> : ''}
        </Panel>
    );
}

export default ReviewImages;
